import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AviationEvent, AviationEventTypeDesc, AviationEventType, TimeZones } from '../../shared/models/aviation-event.model';
import { MatDatepickerInputEvent, MatDialogRef, MatSnackBar } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { eventHours, eventMinutes, eventAMPM } from '../../globals';
import * as MomentTZ from 'moment-timezone';
var EditEventDetailsComponent = /** @class */ (function () {
    function EditEventDetailsComponent(_matDialogRef, data, _aviationEventsService, _fb, _snackBar) {
        this._matDialogRef = _matDialogRef;
        this._aviationEventsService = _aviationEventsService;
        this._fb = _fb;
        this._snackBar = _snackBar;
        this.isLoading = true;
        this.startDateMin = new Date();
        this.endDateMin = this.startDateMin;
        this.timeZones = Object.keys(TimeZones).sort();
        // tslint:disable-next-line:max-line-length
        this.urlRegex = /^((https?|http):\/\/)?(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
        this.eventHours = eventHours;
        this.eventMinutes = eventMinutes;
        this.eventAMPM = eventAMPM;
        this.aviationEvent = data.aviationEvent;
    }
    EditEventDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this._matDialogRef.close(null);
        });
        var currentTimeZoneSimpleName = Object.keys(TimeZones).filter(function (it) { return TimeZones[it] === _this.aviationEvent.timezone; }).pop();
        this.eventTypes = Object.values(AviationEventTypeDesc);
        var currentEventType = AviationEventTypeDesc[AviationEventType[this.aviationEvent.typeId]];
        this.eventStart = MomentTZ.tz(this.aviationEvent.startDateTime, 'UTC');
        this.eventStartDateString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
        this.eventStartTimeString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('HH:mm');
        this.eventEnd = MomentTZ.tz(this.aviationEvent.endDateTime, 'UTC');
        this.eventEndDateString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
        this.eventEndTimeString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('HH:mm');
        this.startDate = this.eventStart.clone().tz(this.aviationEvent.timezone).toDate();
        this.endDate = this.eventEnd.clone().tz(this.aviationEvent.timezone).toDate();
        this.startHour = this.eventStart.clone().tz(this.aviationEvent.timezone).format('h');
        this.startMin = this.eventStart.clone().tz(this.aviationEvent.timezone).format('mm');
        this.startAMPM = this.eventStart.clone().tz(this.aviationEvent.timezone).format('A');
        this.endHour = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('h');
        this.endMin = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('mm');
        this.endAMPM = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('A');
        this.formGroup = this._fb.group({
            startDate: [this.startDate, Validators.required],
            endDate: [this.endDate, Validators.required],
            startHour: [this.startHour, Validators.required],
            startMin: [this.startMin, Validators.required],
            startAMPM: [this.startAMPM, Validators.required],
            endHour: [this.endHour, Validators.required],
            endMin: [this.endMin, Validators.required],
            endAMPM: [this.endAMPM, Validators.required],
            timezone: [currentTimeZoneSimpleName || '', Validators.required],
            webinarRegistrationLink: [this.aviationEvent.webinarRegistrationLink,
                [Validators.maxLength(256), Validators.pattern(this.urlRegex)]],
            informationWebsite: [this.aviationEvent.informationWebsite,
                [Validators.maxLength(256), Validators.pattern(this.urlRegex)]],
            websiteCustomLabel: [this.aviationEvent.websiteCustomLabel, [Validators.maxLength(50)]],
            type: [currentEventType, [Validators.maxLength(256)]],
            cost: [this.aviationEvent.cost || 'Unknown', [Validators.maxLength(256)]]
        }, { updateOn: 'submit' });
        this.isLoading = false;
    };
    EditEventDetailsComponent.prototype.showDateError = function () {
        var startDate = this.formGroup.value.startDate;
        startDate.setHours(0, 0, 0, 0);
        var endDate = this.formGroup.value.endDate;
        endDate.setHours(0, 0, 0, 0);
        var startHour = +this.formGroup.value.startHour;
        if (startHour === 12) {
            startHour = 0;
        }
        startHour = this.formGroup.value.startAMPM === 'PM' ? startHour + 12 : startHour;
        var endHour = +this.formGroup.value.endHour;
        if (endHour === 12) {
            endHour = 0;
        }
        endHour = this.formGroup.value.endAMPM === 'PM' ? endHour + 12 : endHour;
        var dateBoolean = startDate && endDate && startDate.getTime() > endDate.getTime();
        if (startDate && endDate && startDate.getTime() === endDate.getTime()) {
            return startHour > endHour || (startHour === endHour && +this.formGroup.value.startMin > +this.formGroup.value.endMin);
        }
        return dateBoolean;
    };
    EditEventDetailsComponent.prototype.eventDateChange = function (type, event) {
        var element = event.targetElement;
        if (element.getAttribute('name') === 'startDate') {
            this.endDateMin = event.value;
        }
    };
    EditEventDetailsComponent.prototype.buildZonedTime = function (date, time, timezone) {
        var month = ('0' + (date.getMonth() + 1)).slice(-2);
        var day = ('0' + date.getDate()).slice(-2);
        var year = date.getFullYear();
        var localTime = MomentTZ.tz(year + "-" + month + "-" + day + " " + time, timezone);
        return localTime.utc().format('MM/DD/YYYY h:mm:ss A');
    };
    EditEventDetailsComponent.prototype.close = function (result) {
        if (result === void 0) { result = { cancelBtnClicked: true, success: false }; }
        if (result) {
            this._matDialogRef.close(result);
        }
    };
    EditEventDetailsComponent.prototype.cancel = function () {
        this._matDialogRef.close(null);
    };
    EditEventDetailsComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var TEMP_aviationEvent, tzName, startDate, startTime, endDate, endTime, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        TEMP_aviationEvent = this.aviationEvent;
                        tzName = TimeZones[this.formGroup.value.timezone];
                        startDate = new Date(this.formGroup.value.startDate);
                        startTime = +this.formGroup.value.startHour < 10 ? '0' + this.formGroup.value.startHour : this.formGroup.value.startHour;
                        // if startTime is 12:00 AM, set to 00:00
                        if (+this.formGroup.value.startHour === 12 && this.formGroup.value.startAMPM === 'AM') {
                            startTime = '00';
                        }
                        else {
                            startTime = this.formGroup.value.startAMPM === 'PM' && +this.formGroup.value.startHour < 12 ? (+startTime + 12).toString() :
                                startTime;
                        }
                        startTime = startTime + ':' + this.formGroup.value.startMin;
                        endDate = new Date(this.formGroup.value.endDate);
                        endTime = +this.formGroup.value.endHour < 10 ? '0' + this.formGroup.value.endHour : this.formGroup.value.endHour;
                        // if endTime is 12:00 AM, set to 00:00
                        if (+this.formGroup.value.endHour === 12 && this.formGroup.value.endAMPM === 'AM') {
                            endTime = '00';
                        }
                        else {
                            endTime = this.formGroup.value.endAMPM === 'PM' && +this.formGroup.value.endHour < 12 ? (+endTime + 12).toString() : endTime;
                        }
                        endTime = endTime + ':' + this.formGroup.value.endMin;
                        if (this.formGroup.invalid) {
                            this._snackBar.open('Form field validation failed. check form values', null, { duration: 5000 });
                            return [2 /*return*/];
                        }
                        else if (this.showDateError()) {
                            this._snackBar.open('Start time cannot be after end time, check end time is not before start time', null, { duration: 5000 });
                            return [2 /*return*/];
                        }
                        if (this.formGroup.value.webinarRegistrationLink && this.formGroup.value.webinarRegistrationLink.trim().length) {
                            this.aviationEvent.webinarRegistrationLink = this.formGroup.value.webinarRegistrationLink.trim();
                        }
                        else {
                            this.aviationEvent.webinarRegistrationLink = null;
                        }
                        if (this.formGroup.value.informationWebsite && this.formGroup.value.informationWebsite.trim().length) {
                            this.aviationEvent.informationWebsite = this.formGroup.value.informationWebsite.trim();
                        }
                        else {
                            this.aviationEvent.informationWebsite = null;
                        }
                        if (this.formGroup.value.websiteCustomLabel && this.formGroup.value.websiteCustomLabel.trim().length) {
                            this.aviationEvent.websiteCustomLabel = this.formGroup.value.websiteCustomLabel.trim();
                        }
                        else {
                            this.aviationEvent.websiteCustomLabel = null;
                        }
                        if (this.formGroup.value.cost && this.formGroup.value.cost.trim().length && this.formGroup.value.cost.trim() !== 'Unknown') {
                            this.aviationEvent.cost = this.formGroup.value.cost.trim();
                        }
                        else {
                            this.aviationEvent.cost = null;
                        }
                        // this.aviationEvent.format = this.formGroup.value.format;
                        this.aviationEvent.type = AviationEvent.parseEventFromString(this.formGroup.value.type);
                        this.aviationEvent.typeId = this.aviationEvent.type;
                        this.aviationEvent.timezone = tzName;
                        this.aviationEvent.startDateTimeUTC = this.buildZonedTime(startDate, startTime, tzName);
                        this.aviationEvent.endDateTimeUTC = this.buildZonedTime(endDate, endTime, tzName);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._aviationEventsService.updateAviationEvent(this.aviationEvent)];
                    case 2:
                        _a.sent();
                        this.close({ cancelBtnClicked: false, success: true });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.aviationEvent = TEMP_aviationEvent;
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return EditEventDetailsComponent;
}());
export { EditEventDetailsComponent };
